import store from 'store'
import { showModal } from 'modals/ducks'
import { EMAIL_MODAL } from 'Email/constants'
import { notify } from 'utils/notify'
import { fetchMessage } from 'utils/connectMessage'

export default (messageId) => {
  fetchMessage(messageId)
    .then(msg => {
      store.dispatch(showModal({ type: EMAIL_MODAL, props: { isFromInbox: true, email: msg } }))
    })
    .catch(() => {
      notify('Email not found.', { type: 'error' })
    })
}
